(() => {
  const loader = document.querySelector('[data-jungle-loader]');
  if (!loader) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let seen = false;
  let dismissed = false;

  try {
    seen = sessionStorage.getItem('jungle-loader-seen') === 'true';
  } catch (error) {
    seen = false;
  }

  const delay = reduceMotion || seen ? 80 : 1150;

  document.documentElement.classList.add('jungle-is-loading');

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    loader.classList.add('is-hidden');
    document.documentElement.classList.remove('jungle-is-loading');
    try {
      sessionStorage.setItem('jungle-loader-seen', 'true');
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
    window.setTimeout(() => loader.remove(), 500);
  };

  if (document.readyState === 'complete') {
    window.setTimeout(dismiss, delay);
  } else {
    window.addEventListener('load', () => window.setTimeout(dismiss, delay), { once: true });
  }

  window.setTimeout(dismiss, delay + 1800);
})();
